/* social-proof-carousel.js */
(function () {
  'use strict';

  var RATIO = 1.33;
  var GAP   = 10;

  function init(cfg) {
    var id      = cfg.id;
    var speed   = cfg.speed   || 4000;
    var featPct = (cfg.featPct || 48) / 100;

    var viewport = document.getElementById('spc-viewport-' + id);
    var track    = document.getElementById('spc-track-'    + id);
    var dotsEl   = document.getElementById('spc-dots-'     + id);
    var prevBtn  = document.getElementById('spc-prev-'     + id);
    var nextBtn  = document.getElementById('spc-next-'     + id);

    if (!viewport || !track) return;

    var slides = Array.from(track.querySelectorAll('.spc-slide'));
    var n      = slides.length;
    if (n === 0) return;

    var dots  = dotsEl ? Array.from(dotsEl.querySelectorAll('.spc-dot')) : [];
    var cur   = 1;
    var timer = null;

    function isMobile() { return window.innerWidth <= 768; }

    function calcSizes() {
      var vw    = viewport.offsetWidth;
      if (isMobile()) {
        // Mobile: featured takes ~88%, next peeks ~10% on right
        var featW = Math.round(vw * 0.88);
        var normW = Math.round(vw * 0.10);
        var h     = Math.round(featW * 1.6);
        return { vw: vw, featW: featW, normW: normW, h: h };
      }
      var featPctVal = featPct;
      var featW = Math.round(vw * featPctVal);
      var normW = Math.round((vw - featW - GAP * 2) / 2);
      var h     = Math.round(featW * RATIO);
      return { vw: vw, featW: featW, normW: normW, h: h };
    }

    function setWidths(s, animate) {
      var featH = s.h;
      var normH = Math.round(s.h * 0.88); // normals ~88% height

      // Set viewport height to featured height
      viewport.style.height = featH + 'px';

      slides.forEach(function (sl, i) {
        var isFeat = (i === cur);
        sl.classList.toggle('is-featured', isFeat);
        // Only animate width — height changes instantly to avoid jump
        sl.style.transition = animate ? 'width 0.5s cubic-bezier(0.4,0,0.2,1)' : 'none';
        sl.style.width      = (isFeat ? s.featW : s.normW) + 'px';
        sl.style.height     = (isFeat ? featH : normH) + 'px';
        sl.style.alignSelf  = 'flex-end';
        var inner = sl.querySelector('.spc-slide-inner');
        if (inner) inner.style.height = (isFeat ? featH : normH) + 'px';
      });

      // Calculate translateX
      var offset;
      if (isMobile()) {
        // Mobile: featured always at left edge (position 0)
        offset = cur * (s.normW + GAP);
        // Each slide before cur was normW wide (they're now small)
        // Actually recalculate: sum of all slides before cur
        offset = 0;
        for (var i = 0; i < cur; i++) {
          // All non-featured slides are normW
          offset += s.normW + GAP;
        }
      } else {
        // Desktop: featured on right — 2 normals visible left of it
        var featLeft = cur * (s.normW + GAP);
        offset = featLeft - 1 * (s.normW + GAP);
        if (offset < 0) offset = 0;
      }

      track.style.transition = animate ? 'transform 0.5s cubic-bezier(0.4,0,0.2,1)' : 'none';
      track.style.transform  = 'translateX(-' + offset + 'px)';
    }

    function playFeatured() {
      var sl = slides[cur];
      if (!sl) return;
      var v = sl.querySelector('video');
      var btn = sl.querySelector('.spc-play-btn');
      if (v && v.paused) {
        v.muted = true;
        v.play().catch(function () {});
        if (btn) btn.classList.add('hidden');
      }
    }

    function goTo(i, animate) {
      cur = ((i % n) + n) % n;
      dots.forEach(function (d, j) { d.classList.toggle('active', j === cur); });
      pauseAll();
      setWidths(calcSizes(), animate !== false);

      // Play featured video after width transition ends
      if (animate !== false) {
        var done = false;
        var featSlide = slides[cur];
        function onEnd() {
          if (done) return;
          done = true;
          featSlide.removeEventListener('transitionend', onEnd);
          playFeatured();
        }
        featSlide.addEventListener('transitionend', onEnd);
        // Fallback in case transitionend doesn't fire
        setTimeout(function () { onEnd(); }, 600);
      } else {
        setTimeout(playFeatured, 100);
      }
    }

    function next() { goTo(cur + 1); }
    function prev() { goTo(cur - 1); }

    function startAuto() { stopAuto(); timer = setInterval(next, speed); }
    function stopAuto()  { if (timer) { clearInterval(timer); timer = null; } }

    function pauseAll() {
      slides.forEach(function (sl) {
        var v = sl.querySelector('video');
        if (v) { v.pause(); v.muted = true; }
        var cover = sl.querySelector('.spc-cover');
        if (cover) cover.style.display = '';
        var btn = sl.querySelector('.spc-play-btn');
        if (btn) btn.classList.remove('hidden');
      });
    }

    slides.forEach(function (sl) {
      var btn   = sl.querySelector('.spc-play-btn');
      var cover = sl.querySelector('.spc-cover');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var v = sl.querySelector('video');
        if (!v) return;
        if (v.paused) {
          pauseAll(); stopAuto();
          if (cover) cover.style.display = 'none';
          v.play();
          btn.classList.add('hidden');
        } else {
          v.pause();
          if (cover) cover.style.display = '';
          btn.classList.remove('hidden');
          startAuto();
        }
      });
    });

    slides.forEach(function (sl, i) {
      sl.addEventListener('click', function (e) {
        if (e.target.closest('.spc-play-btn')) return;
        if (i !== cur) { stopAuto(); goTo(i); startAuto(); }
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); stopAuto(); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); stopAuto(); startAuto(); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(parseInt(d.dataset.i, 10)); stopAuto(); startAuto();
      });
    });

    var tx = 0;
    viewport.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchend',   function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); stopAuto(); startAuto(); }
    }, { passive: true });

    var wrap = document.getElementById('spc-wrap-' + id);
    if (wrap) {
      wrap.addEventListener('mouseenter', stopAuto);
      wrap.addEventListener('mouseleave', startAuto);
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { setWidths(calcSizes(), false); }, 150);
    });

    // Init: wait until viewport has real width
    function tryInit() {
      var s = calcSizes();
      if (s.vw === 0) { requestAnimationFrame(tryInit); return; }
      setWidths(s, false);
      startAuto();
      // Play first featured video once it's ready
      var v = slides[0] && slides[0].querySelector('video');
      if (v) {
        if (v.readyState >= 3) {
          playFeatured();
        } else {
          v.addEventListener('canplay', function onReady() {
            v.removeEventListener('canplay', onReady);
            playFeatured();
          });
        }
      }
    }

    // Small delay to let Shopify theme finish rendering
    setTimeout(tryInit, 100);
  }

  function run() {
    (window.__spcQueue || []).forEach(init);
    window.__spcQueue = { push: init };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () {
    if (Array.isArray(window.__spcQueue)) window.__spcQueue.forEach(init);
    window.__spcQueue = { push: init };
  });
})();